// Mapowanie uuid dla encji measurementInfo (parentUuid dla /files).
// W offline tworzymy "tymczasowe" uuid (tempId) w odpowiedzi PUT /measurement/info.
// Podczas synchronizacji backend zwraca realne uuid measurementInfo, więc zapisujemy mapę:
// tempMeasurementInfoUuid -> realMeasurementInfoUuid.

export type OfflineMeasurementInfoUuidMapState = Record<string, string>; // temp -> real

const STORAGE_KEY = 'offlineMeasurementInfoUuidMap';

const readState = (): OfflineMeasurementInfoUuidMapState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return (JSON.parse(raw) as OfflineMeasurementInfoUuidMapState) || {};
  } catch (e) {
    console.error('Error reading offline measurementInfo uuid map:', e);
    return {};
  }
};

const writeState = (state: OfflineMeasurementInfoUuidMapState) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error('Error writing offline measurementInfo uuid map:', e);
  }
};

export const setOfflineMeasurementInfoUuidMapping = (
  tempMeasurementInfoUuid: string,
  realMeasurementInfoUuid: string
) => {
  const state = readState();
  writeState({
    ...state,
    [tempMeasurementInfoUuid]: realMeasurementInfoUuid,
  });
};

export const resolveOfflineMeasurementInfoUuid = (uuid: string) => {
  const state = readState();
  return state[uuid] || uuid;
};

export const getOfflineMeasurementInfoUuidMap = () => readState();

export const clearOfflineMeasurementInfoUuidMap = () => writeState({});
